export default "__VITE_ASSET__ClQSWXOn__"